module.exports = __webpack_public_path__ + "static/media/AZdark.e9f7a38c.svg";